<template>
  <div>
    <div v-if="$route.path.indexOf('_setting') === -1">
      <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
        <SpFilterFormItem prop="status" label="">
          <el-input v-model="formData.name" placeholder="请输入祝福分类" />
        </SpFilterFormItem>
        <SpFilterFormItem prop="status" label="">
          <el-button type="primary" @click="addCategory">添加送礼祝福分类</el-button>
        </SpFilterFormItem>
      </SpFilterForm>
      <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="250" :row-actions-align="'left'"
        :fixed-row-action="true" url="/giftingorderblessing/group/list" :hooks="{
          beforeSearch: beforeSearch,
          afterSearch: afterSearch
        }" :split-count="5">
      </SpFinder>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { isArray } from '@/utils';
import { copyBundleDiscount, deleteBundleDistributorList, deleteGiftingorderblessingGroup, putGiftingorderblessingGroup } from '@/api/giving'
import { useDialog } from '@shopex/finder'

const commonActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '保存', key: 'save', type: 'primary', size: 'default' }
]

export default {
  components: {
  },
  data() {
    return {
      setting: createSetting({
        columns: [
          { name: '分类ID', key: 'id' },
          { name: '分类名称', key: 'name' },
          {
            name: '送礼分享设置', key: 'status_msg',
            render: (h, { row }) => {
              return <div>{row.has_share_setting ? '已设置' : '未设置'}</div>
            }
          },
          {
            name: '送礼卡封面', key: 'last_updated_time',
            render: (h, { row }) => {
              return <div>{row.has_card_image ? '已设置' : '未设置'}</div>
            }
          },
          {
            name: '送礼祝福语', key: 'created',
            render: (h, { row }) => {
              return <div>{row.has_blessing ? '已设置' : '未设置'}</div>
            }
          },
          {
            name: '是否启用', key: 'status',
            render: (h, { row }) => {
              return <el-switch
                v-model={row.status}
                on-change={(value) => this.onStatusChange(row, value)}
                active-value='1'
                inactive-value='0'
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            }
          },
          {
            name: '排序',
            key: 'sort',
            headRender: (h) => {
              return (
                <div>
                  优先级
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="排序数值越大，弹窗展示的位置越靠前，数值相同则参考创建时间由进到远排序"
                  >
                    <span slot="reference"><i class="el-icon-info"></i></span>
                  </el-popover>
                </div>
              )
            },
            render: (h, { row }) => {
              return <el-input v-model={row.sort} placeholder='序号' on-change={(value) => this.onSortChange(row, value)} />
            }
          },
        ],
        actions: [
          {
            name: '编辑',
            key: 'edit',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: async (row) => {
                this.addCategory(row[0])
              }
            }
          },
          {
            name: '设置内容',
            key: 'show',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: async (row) => {
                this.$router.push({ path: this.matchHidePage('setting'), query: { id: row[0].id } })
              }
            }
          },
          {
            name: '删除',
            key: 'delete',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: (row) => {
                this.handleDeleteDialog(row[0])
              }
            }
          },
        ]
      }),
      formData: {
        name: '',
      },
    }
  },
  methods: {
    // 添加分类
    addCategory(item) {
      console.log("🚢 ~ 当前打印的内容 ~ item:", item);
      useDialog(null, {
        title: item.id ? '编辑祝福语分类' : `添加祝福语分类`,
        width: '50%',
        info: item.id ? item : {},
        component: () => import('./comps/add-category.vue'),
        actions: commonActions
      }).then(() => {
        this.$refs.finder.refresh()
      })
    },
    onStatusChange(row, v) {
      putGiftingorderblessingGroup({ id: row.id, status: v }).then(res => {
      })
    },
    onSortChange(row, v) {
      putGiftingorderblessingGroup({ id: row.id, sort: v }).then(res => {
      })
    },
    beforeSearch(params) {
      const { name } = this.formData
      const pamars = {
        ...params,
        name,
      }
      return pamars
    },
    afterSearch(res) {
      const { data } = res.data
      return data
    },
    handleDeleteDialog(row) {
      this.$confirm('确定删除分类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGiftingorderblessingGroup({ id: row.id }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.$nextTick(() => {
            this.$refs.finder.refresh()
          })
        })
      })
        .catch(() => { })
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        name: ''
      }
      this.$refs.finder.refresh(true)
    },
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.sp-finder-hd {
  padding-top: 10px !important;
}

.view-template-dialog {
  .sp-finder-hd {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;

    .el-form {
      margin: 0 !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>
